// 电桩详情--订单信息
import React, { Component } from "react";
import ScGridTable from "@/components/display/table/gridTableCore";
import {
  getStubOrderInfoList,
  endCodeInfo,
  appKeyInfo,
  getCityList,
  stubGroupNameSearch,
  prefixFile,
  orderForceStop,
} from "@/fetch/fetchApi";
import fetchHandlerFunc from "@/fetch/fetchHandler";
import FormCore from "@/components/display/form/formCore";
import moment from "moment";
import PropTypes from "prop-types";
import { Modal, message } from "antd";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
// 其他组件
import OrderDetailInfo from "./orderDetailInfo";
import RefreshGrid from "../../../utils/refreshGrid";
import StubGroupChoose from "./stubGroupChoose";
@connect((state) => state)
class StubOrderInfo extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubOrderInfo;
    this.yunwei = this.props.intl.messages.commonBase;
    let stubId = "";
    let time = "";
    if (this.props.params) {
      if (this.props.params.key) {
        stubId = this.props.params.key;
      } else if (this.props.params.stubId) {
        stubId = this.props.params.stubId;
      }
      if (this.props.params.searchTime) {
        time = moment(this.props.params.searchTime).format("YYYY-MM-DD");
      }
    }
    // this.props.params
    // ? this.props.params.key
    //   ? this.props.params.key
    //   : this.props.params.stubId
    //     ? this.props.params.stubId
    //     : ""
    // : ""

    // this.props.params
    // ? this.props.params.searchTime
    //   ? moment(this.props.params.searchTime).format("YYYY-MM-DD")
    //   : ""
    // : ""
    this.state = {
      stubId: stubId,
      time: time,
      typeOption: [
        {
          text: this.props.intl.messages.commonBase.wz10, // '全部',
          value: "",
        },
      ],
      searchStubGroupId: "",
      choosedStubGroupName: "",
      seeChooseState: false,
    };
    this.layout = [
      "inline", // 横向布局
      "vertical", // 弹窗布局
      "horizontal", // 纵向布局
    ];
    this.tableKeyRamdom = `orderInfoTableStub${Math.floor(Math.random() * 100)}`;
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    /**
     * 初始化form查询表单
     */
    this.setState({
      formConfig: this.initFormConfig(),
    });
    this.initTable();
  }

  componentDidMount() {
    const time =
      this.state.time === ""
        ? `${moment(new Date()).subtract(6, "d").format("YYYY-MM-DD")},${moment(new Date())
            .subtract(0, "d")
            .format("YYYY-MM-DD")}`
        : `${moment(this.state.time).subtract(6, "d").format("YYYY-MM-DD")},${moment(
            this.state.time,
          )
            .subtract(0, "d")
            .format("YYYY-MM-DD")}`;

    this.fetchApi({
      stubId: this.state.stubId,
      date: time,
    });
  }

  /**
   * 初始化表格方法
   */
  initFormConfig() {
    // 设置查询时间
    const formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: this.internationalization.wz1, // '请输入业务订单号',
          param: {
            name: "bussinessId",
            type: "string",
          },
          labelName: this.internationalization.wz2, // '业务订单号',
          required: false,
        },
        {
          type: "input",
          placeholder: this.internationalization.wz3, // '请输入平台订单号',
          param: {
            name: "platformId",
            type: "string",
          },
          labelName: this.internationalization.wz4, // '平台订单号',
          required: false,
        },
        {
          type: "input",
          placeholder: this.internationalization.wz5, // '请输入设备编号',
          param: {
            name: "stubId",
            type: "string",
          },
          defaultValue: this.state.stubId,
          labelName: this.internationalization.wz6, // '设备编号',
          required: false,
        },
        {
          type: "input",
          placeholder: "请输入用户手机号", // '请输入用户编号',
          param: {
            name: "phone",
            type: "string",
          },
          labelName: "用户手机号", // '用户手机号：',
          required: false,
        },
        {
          type: "autoWatchFetch",
          placeholder: "请输入电站名称", // '请输入电站名称',
          labelName: "电站名称", // '电站名称',
          param: {
            name: "stubGroupId",
            type: "string",
          },
          optionInfo: {
            optionKey: "id",
            optionText: "name",
          },
          searchParam: {},
          searchListName: "stubGroupList",
          searchKey: "stubGroupListByName",
          required: false,
          onSelect: (value, option) => {
            this.setState({
              searchStubGroupId: option.key,
            });
          },
          onChange: () => {
            if (this.state.searchStubGroupId) {
              this.setState({
                searchStubGroupId: "",
              });
            }
          },
          sourceApi: stubGroupNameSearch,
        },
        {
          type: "areaPicker",
          isPickArea: !0,
          placeholder: "请选择地区", // '请选择地区',
          pickOnSelect: true,
          param: {
            name: "cityId", // 与form表单绑定的参数名
            type: "array",
          },
          required: !1,
          labelName: "地区", // '地区',
          className: "allshow",
          sourceApi: getCityList,
          mapKey: {
            label: "label",
            value: "value",
            children: "children",
          },
        },
        {
          type: "autoWatchFetch",
          placeholder: this.internationalization.wz9, // '请输入充电应用',
          param: {
            name: "appkey",
            type: "string",
          },
          optionInfo: {
            optionKey: "orgCode",
            optionText: "companyName",
          },
          searchParam: {},
          searchKey: "appKeyName",
          searchListName: "appKeyList",
          labelName: this.internationalization.wz10, // '充电应用',
          required: false,
          onSelect: (value, option) => {
            this.setState({
              searchAppKey: option.key,
            });
          },
          onChange: () => {
            if (this.state.searchAppKey) {
              this.setState({
                searchAppKey: "",
              });
            }
          },
          sourceApi: appKeyInfo,
        },
        {
          type: "date",
          dateType: "rangeDate",
          placeholder: [
            this.internationalization.placeholder1,
            this.internationalization.placeholder1,
          ],
          param: {
            name: "date",
            type: "array",
          },
          width: "200px",
          allowClear: false,
          defaultValue:
            this.state.time === ""
              ? [moment(new Date()).subtract(6, "d"), moment(new Date())]
              : [moment(this.state.time).subtract(6, "d"), moment(this.state.time)],
          validator: {
            // 日期自定义校验规则
            vtype: "date", // 校验名称
            min_val: 0, // 可选最小天数
            max_val: 31, // 最大可选天数
          }, // 自定义校验规则
          labelName: this.internationalization.wz11, // '订单结束时间:',
          required: !1,
        },
        {
          type: "endCodeSelect",
          placeholder: this.internationalization.wz12, // '请选择停止原因',
          labelName: this.internationalization.wz13, // '停止原因',
          param: {
            name: "endCode",
            type: "string",
          },
          onSelect: (value, option) => {
            this.setState({
              searchEndCode: option.key,
            });
          },
          onChange: () => {
            this.setState({
              searchEndCode: "",
            });
          },
          options: [],
          required: false,
          sourceApi: endCodeInfo,
          showParam: "endCodeName",
          choseParam: "endCodeName",
          keyParam: "endCode",
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              text: this.internationalization.btn1, // '查询',
              // icon: 'search'
            },
            {
              btnType: "button",
              text: "导出", // '查询',
              handler: (e, param) => {
                const newParam = param;
                const date = newParam.date.split(",");
                newParam.startTime = date[0];
                newParam.endTime = date[1];
                delete newParam.date;
                // 设置充电app
                if (newParam.appkey) {
                  if (this.state.searchAppKey) {
                    newParam.appkey = this.state.searchAppKey;
                  }
                } else {
                  newParam.appkey = "";
                }
                // newParam.appkey = newParam.appkey
                //   ? this.state.searchAppKey
                //     ? this.state.searchAppKey
                //     : newParam.appkey
                //   : "";
                // 设置停止原因
                if (newParam.endCode) {
                  if (this.state.searchEndCode) {
                    newParam.endCode = this.state.searchEndCode;
                  }
                } else {
                  newParam.endCode = "";
                }
                // newParam.endCode = newParam.endCode
                //   ? this.state.searchEndCode
                //     ? this.state.searchEndCode
                //     : newParam.endCode
                //   : "";
                // 设置电站名称
                if (newParam.stubGroupId) {
                  if (this.state.searchStubGroupId) {
                    newParam.stubGroupId = this.state.searchStubGroupId;
                  }
                } else {
                  newParam.stubGroupId = "";
                }
                // newParam.stubGroupId = newParam.stubGroupId
                //   ? this.state.searchStubGroupId
                //     ? this.state.searchStubGroupId
                //     : newParam.stubGroupId
                //   : "";
                // 城市id格式化
                newParam.cityId =
                  newParam.cityId === undefined
                    ? ""
                    : newParam.cityId
                        .toString()
                        .slice(
                          newParam.cityId.toString().lastIndexOf(",") + 1,
                          newParam.cityId.toString().length,
                        );

                let paramString = "";
                Object.keys(newParam).forEach((key) => {
                  const paraminfo = newParam[key] ? newParam[key] : "";
                  paramString += `${key}=${paraminfo}&`;
                });
                console.log(paramString);
                this.exportOrder(paramString);
              },
            },
            // {
            //     btnType: 'expBtn',
            //     text: '导出EXCEL',
            //     tableKey: this.tableKeyRamdom,
            //     serviceName: 'orderInfoList',
            //     fileName: '订单',
            //     type: 'default'
            // }
          ],
        },
      ], // 设置表单元素
      layout: this.layout[0], // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      defaultParams: {},
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: this.tableKeyRamdom,
    };

    return formConfig;
  }

  initTable() {
    /**
     * 初始化表格
     */
    this.setState({
      tableConfig: {
        tableColumns: [
          {
            name: this.internationalization.wz2, // '业务订单号',
            key: "outOrderId",
            align: "left",
            colType: "textCol",
          },
          {
            name: this.internationalization.title2, // '平台订单号',
            key: "key",
            align: "left",
            colType: "textCol",
          },
          {
            name: this.internationalization.wz6, // '设备编号',
            key: "stubId",
            align: "left",
            colType: "textCol",
          },
          {
            name: this.internationalization.wz14, // '电站',
            key: "stubGroupName",
            align: "left",
            colType: "tipCol",
          },
          {
            name: this.internationalization.wz15, // '地区',
            key: "cityName",
            align: "left",
            colType: "textCol",
          },
          // {
          //     name:  '设备类型' ,//'地区',
          //     key: 'cityName',
          //     align: 'left',
          //     colType:'textCol',
          //     render: (value, row, index) => {
          //         switch (value) {
          //             case 0:
          //                 return '交流电';//'交流电';
          //             case 1:
          //                 return '直流电';//'直流电';
          //             case 2:
          //                 return '交直流';//'交直流';
          //             default:
          //                 return '未知';//'未知'
          //         }
          //     }
          // },
          // {
          //     name:  '运营类型' ,//'地区',
          //     key: 'operationMode',
          //     align: 'left',
          //     colType:'textCol',
          //     render: (value, row, index) => {
          //         if (row.operationProperty == '1') {
          //             if (value == '0') {
          //                 return (<div>{this.yunwei.wz1}-{this.yunwei.wz6}</div>)
          //             } else if (value == '1') {
          //                 return (<div>{this.yunwei.wz1}-{this.yunwei.wz5}</div>)
          //             } else if (value == '2') {
          //                 return (<div>{this.yunwei.wz1}-{this.yunwei.wz3}</div>)
          //             } else if (value == '3') {
          //                 return (<div>{this.yunwei.wz1}-{this.yunwei.wz4}</div>)
          //             } else if (value == '5') {
          //                 return (<div>{this.yunwei.wz1}-{this.yunwei.wz7}</div>)
          //             } else {
          //                 return (<div>--</div>)
          //             }
          //         } else if (row.operationProperty == '0') {
          //             if (value == '0') {
          //                 return (<div>{this.yunwei.wz2}-{this.yunwei.wz8}</div>)
          //             } else if (value == '1') {
          //                 return (<div>{this.yunwei.wz2}-{this.yunwei.wz9}</div>)
          //             } else if (value == '2') {
          //                 return (<div>--</div>)
          //             }

          //         } else {
          //             return '--'
          //         }
          //     }
          // },
          {
            name: this.internationalization.wz8, // '用户编号',
            key: "userId",
            align: "left",
            colType: "textCol",
          },
          {
            name: this.internationalization.wz10, // '充电应用',
            key: "appkeyName",
            align: "left",
            colType: "tipCol",
          },
          {
            name: this.internationalization.title3, // '充电时间',
            message: (
              <div className="mcjs">
                <p>充电时间为平台记录时间，充电时间大于实际充电时间。</p>
              </div>
            ),
            key: "timeStart",
            align: "left",
            colType: "textCol",
            render: (text, record) => {
              return (
                <div>
                  <span>
                    {record.timeStart}~{record.timeEnd}
                  </span>
                </div>
              );
            },
          },
          {
            name: this.internationalization.wz16, // '实际充电时间'
            message: (
              <div className="mcjs">
                <p>实际充电时间为桩端上报时间</p>
              </div>
            ),
            key: "realStartTime",
            align: "left",
            colType: "textCol",
            render: (text, record) => {
              return (
                <div>
                  <span>
                    {record.realStartTime}~{record.realEndTime}
                  </span>
                </div>
              );
            },
          },
          {
            name: this.internationalization.wz17, // '充电时长' ,
            key: "timeChargeFormat",
            align: "left",
            colType: "textCol",
          },
          {
            name: this.internationalization.title4, // '电量(度)',
            key: "power",
            align: "center",
            colType: "numCol",
          },
          {
            name: "订单金额(元)", // '订单金额(元)',
            key: "feeTotal",
            align: "center",
            colType: "numCol",
          },
          {
            name: this.internationalization.title5, // '充电状态',
            key: "status",
            align: "left",
            colType: "textCol",
            render: (value) => {
              switch (value) {
                case 0:
                  return this.internationalization.title6; // '启动中';
                case 1:
                  return this.internationalization.title7; // '充电中';
                case 9:
                  return this.internationalization.title8; // '充电完成';
                default:
                  return "--";
              }
            },
          },
          {
            name: "车型号",
            key: "carType",
            align: "left",
            colType: "textCol",
            render: (text) => (text || text === 0 ? text : "--"),
          },
          {
            name: "开始SOC(%)",
            key: "socStart",
            align: "left",
            colType: "textCol",
            render: (text) => (text || text === 0 ? text : "--"),
          },
          {
            name: "结束SOC(%)",
            key: "socEnd",
            align: "left",
            colType: "textCol",
          },
          {
            name: this.internationalization.title9, // '停止原因',
            key: "status",
            align: "left",
            colType: "tipCol",
            render: (value, row) => {
              if (row.endInfo) {
                return row.endInfo;
              } else {
                return "--";
              }
            },
          },
          {
            name: this.internationalization.action, // '操作',
            key: "action",
            fix: "right",
            // width: 150,
            colType: "action",
            actionMap: [
              {
                type: "href",
                actionName: this.internationalization.btn3, // '订单详情',
                handler: (res) => {
                  this.orderDetailInfo = res;
                  this.modalVisibleAction("seeDetailVisible", true);
                  this.setState({
                    seeDetailVisible: true,
                  });
                },
              },
              {
                type: "href",
                actionName: this.internationalization.wz18, // '设备数据',
                handler: (res) => {
                  this.openTab(
                    {
                      keyId: "chargeCourse",
                      orderId: res.key,
                    },
                    {
                      key: "chargeCourse",
                      titleText: this.internationalization.wz18, // '设备数据'
                    },
                  );
                  if (this.props.cancelModal) {
                    this.props.cancelModal();
                  }
                },
              },
              {
                type: "href",
                actionName: this.internationalization.wz19, // '模块数据',
                handler: (res) => {
                  this.openTab(
                    {
                      keyId: "powerCourse",
                      orderId: res.key,
                    },
                    {
                      key: "powerCourse",
                      titleText: this.internationalization.wz19, // '模块数据'
                    },
                  );
                  if (this.props.cancelModal) {
                    this.props.cancelModal();
                  }
                },
              },
              {
                type: "href",
                actionName: this.internationalization.wz20, // '平台日志',
                handler: (res) => {
                  this.openTab(
                    {
                      keyId: "0502",
                      orderId: res.key,
                      stubId: res.stubId,
                      startTime: res.timeStart,
                      endTime: res.timeEnd,
                    },
                    {
                      key: "0502",
                      titleText: "桩连平台日志",
                    },
                  );
                  if (this.props.cancelModal) {
                    this.props.cancelModal();
                  }
                },
              },
              {
                type: "confirm",
                actionName: "强制停止",
                popText: () => {
                  return `确定要强制停止订单吗？`;
                },
                render: (record) => {
                  return record.status !== 1 ? null : <span className="tableBtn">强制停止</span>;
                },
                handler: (record) => {
                  console.log("强制停止");
                  fetchHandlerFunc(orderForceStop, {
                    appkey: record.appkey,
                    orderId: record.key,
                  }).then((res) => {
                    if (res.code === "success" || res.code === "ok") {
                      message.success(`订单${record.key}已强制停止`);
                      RefreshGrid(this.context.store, this.tableKeyRamdom);
                    }
                  });
                },
              },
            ],
          },
        ],
        tableParam: {
          pageCount: 10,
        },
        tableInfo: {
          hasRow: !1, // 是否显示checkbox
        },
        tableChange: () => {
          // grid翻页页，排序， 筛选过滤时触发
          console.debug("change");
        },
        autoRefresh: !1, // 设置为true 直接加载grid数据
        dataApi: getStubOrderInfoList,
        tableKey: this.tableKeyRamdom,
      },
    });
  }

  // 新开页方法
  openTab = (param, e) => {
    this.props.onAdd(e, param);
  };

  // 关闭modal框方法
  modalVisibleAction(modalVisibleKey, visible) {
    console.log(123);
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  /**
   * 表格数据加载方法
   */
  fetchApi = (param) => {
    const newParam = param;
    console.log(newParam);
    const date = newParam.date.split(",");
    newParam.startTime = date[0];
    newParam.endTime = date[1];
    delete newParam.date;

    // 设置充电app
    if (newParam.appkey) {
      if (this.state.searchAppKey) {
        newParam.appkey = this.state.searchAppKey;
      }
    } else {
      newParam.appkey = "";
    }
    // newParam.appkey = newParam.appkey
    //   ? this.state.searchAppKey
    //     ? this.state.searchAppKey
    //     : newParam.appkey
    //   : "";

    // 设置停止原因
    if (newParam.endCode) {
      if (this.state.searchEndCode) {
        newParam.endCode = this.state.searchEndCode;
      }
    } else {
      newParam.endCode = "";
    }
    // newParam.endCode = newParam.endCode
    //   ? this.state.searchEndCode
    //     ? this.state.searchEndCode
    //     : newParam.endCode
    //   : "";

    // 设置电站名称
    if (newParam.stubGroupId) {
      if (this.state.searchStubGroupId) {
        newParam.stubGroupId = this.state.searchStubGroupId;
      }
    } else {
      newParam.stubGroupId = "";
    }
    // newParam.stubGroupId = newParam.stubGroupId
    //   ? this.state.searchStubGroupId
    //     ? this.state.searchStubGroupId
    //     : newParam.stubGroupId
    //   : "";

    // 城市id格式化
    newParam.cityId =
      newParam.cityId === undefined
        ? ""
        : newParam.cityId
            .toString()
            .slice(
              newParam.cityId.toString().lastIndexOf(",") + 1,
              newParam.cityId.toString().length,
            );

    // 如果正常页面中的表单提交，请执行下面
    return RefreshGrid(this.context.store, this.tableKeyRamdom, newParam);
  };

  // 导出订单
  exportOrder = (paramString) => {
    const excelUrl = `${prefixFile}/exportOrderList.do`;

    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${paramString}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${paramString}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
  };

  // 选择电站操作
  setStubGroupInfo = (record) => {
    // 关闭弹窗
    this.modalVisibleAction("seeChooseState", false);
    this.setState(
      {
        choosedStubGroupName: record.name,
        choosedStubGroupKey: record.key,
      },
      () => {
        console.log(this.state.choosedStubGroupName);
        console.log(this.state.choosedStubGroupKey);
        this.setState({
          formConfig: this.initFormConfig(),
        });
      },
    );
  };

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel stub-orderinfo-table">
          <ScGridTable config={this.state.tableConfig} unTotalMode />
        </div>

        <Modal
          title={this.internationalization.btn6}
          visible={this.state.seeDetailVisible}
          footer={null}
          destroyOnClose
          width="1000px"
          onCancel={() => {
            this.modalVisibleAction("seeDetailVisible", false);
          }}>
          <OrderDetailInfo orderDetailInfo={this.orderDetailInfo} />
        </Modal>

        {/* 选择电站 */}
        <Modal
          title="选择电站"
          width="800px"
          footer={null}
          visible={this.state.seeChooseState}
          onCancel={() => {
            this.modalVisibleAction("seeChooseState", false);
          }}>
          <StubGroupChoose setStubGroupInfo={this.setStubGroupInfo} />
        </Modal>
      </div>
    );
    return Content;
  }
}

export default injectIntl(StubOrderInfo);
StubOrderInfo.propTypes = {
  // layout: PropTypes.string,
  // modalSubmit: PropTypes.func,
  // tableKey: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/stubOrderInfo.js